import React from 'react';
import { ScrollView, View, StyleSheet, Dimensions, Platform } from 'react-native';
import ScrollViewWeb from './web/ScrollView';
import Hint from './hint';
import { connect } from 'react-redux';
import DotTable from './dot-table'

class PlayTable extends React.Component {
    constructor(props) {
        super(props);
        this.scroll = React.createRef();
        this.state = {}
    }
 
    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    render() {
        const CELL_SIZE = this.props.small ? 18 : 28;

        const cellSize = parseInt(this.props.tableSize || `${CELL_SIZE}`) || CELL_SIZE;
        const columns = this.props.table || [];
        const emptyColumns = Math.ceil(Dimensions.get("window").width / cellSize)
        // const drawColumnsCount = Math.max(emptyColumns, columns.length + 2)

        const Scroller = Platform.OS === 'web' ? ScrollViewWeb : ScrollView;

        return <View style={styles.innerContainer} >
                <Hint 
                    message={`กดใส่ผล แดง/น้ำเงิน อย่างน้อย 4 ตัวท้าย เพื่อเริ่มคำนวณ หรือ กดเลือกห้อง SA gaming ด้านบน`}
                    height={100}
                    width={300}
                    open={this.props.results.length <= 0}
                />
                <Scroller
                    style={styles.container}
                    horizontal={true}
                    ref={this.scroll}
                    onContentSizeChange={(contentWidth, contentHeight)=>{        
                        if (columns.length >= emptyColumns) {
                            this.scroll.current.scrollToEnd({ animated: true });
                        }
                    }}>

                <DotTable 
                    width={Dimensions.get("window").width }
                    table={this.props.table}
                    tableSize={CELL_SIZE}
                />
                
            </Scroller>
        </View>
    }
}

/*
<Rect
                        x={0}
                        y={0}
                        width={cellSize * drawColumnsCount} height={cellSize * CELL_PER_COLUMN}
                        strokeWidth={2}
                        stroke='rgba(0, 0, 0,0.7)'
                        fill='rgba(0, 0, 0,0.7)'/>
                         */


const mapStateToProps = state => {
    return {
      results: state.results.results,
      table: state.results.table,
    };
};
  
export default connect(mapStateToProps)(PlayTable);


const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        padding: 0,
        margin: 5,
        alignContent: 'flex-start',
        // flex: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        borderBottomWidth: 2,
        borderBottomColor: 'gold',
        borderBottomStyle: 'solid'
    },
    innerContainer: {
        // flex: 0,
        overflow: "hidden",
        alignItems: 'flex-start',
    },
    cell: {
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: '#aaa',
    },
    B: {
        backgroundColor: '#a00',
    },
    P: {
        backgroundColor: '#00c',
    },
    T: {
        backgroundColor: '#080',
    },
});
   